<template>
  <v-row justify="center">
    <v-col
      cols="12"
    >
      <v-card>
        <v-card-title>
          <div class="text-h2">
            Программа - {{ campaign.name }}
          </div>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-tabs
                v-model="currentTab"
                @change="getTabNumber"
              >
                <v-tab>Информация</v-tab>
                <v-tab :disabled="disabledTabItem">
                  Условия и правила
                </v-tab>
                <v-tab :disabled="disabledTabItem">
                  Точки обслуживания
                </v-tab>
                <v-tab :disabled="disabledTabItem">
                  Участники
                </v-tab>
                <v-tab :disabled="disabledTabItem">
                  Дополнительно
                </v-tab>
                <v-tab-item>
                  <campaign-edit
                    :campaign-id="campaignId"
                    :customer-id="customerId"
                    :customer-number="customerNumber"
                  />
                </v-tab-item>
                <v-tab-item :disabled="disabledTabItem">
                  <v-card>
                    <v-card-text>
                      <rule-list
                        :campaign-id="campaignId"
                        :role="role"
                        @rule="getRule"
                      />
                    </v-card-text>
                  </v-card>
                  <v-card>
                    <v-card-text>
                      <condition-list
                        :customer-id="customerId"
                        :role="role"
                        :rule="rule"
                      />
                    </v-card-text>
                  </v-card>
                </v-tab-item>
                <v-tab-item>
                  <v-card>
                    <v-card-text>
                      <point-list />
                    </v-card-text>
                  </v-card>
                </v-tab-item>
                <!--                <v-tab-item>-->
                <!--                  <v-card>-->
                <!--                    <v-card-text>-->
                <!--                      <participant-list />-->
                <!--                    </v-card-text>-->
                <!--                  </v-card>-->
                <!--                </v-tab-item>-->
                <v-tab-item :disabled="disabledTabItem">
                  <user-profile-list />
                </v-tab-item>
                <v-tab-item :disabled="disabledTabItem">
                  <campaign-option
                    :customer-id="customerId"
                    :customer-number="customerNumber"
                  />
                </v-tab-item>
              </v-tabs>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-row>
            <v-col>
              <v-btn
                color="primary"
                outlined
                @click="$router.back()"
              >
                Назад
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import CampaignEdit from "@/views/loyalty/components/campaign/CampaignEdit"
import RuleList from "@/views/loyalty/components/rule/RuleList"
import ConditionList from "@/views/loyalty/components/condition/ConditionList"
import PointList from "@/views/loyalty/components/point/PointList"
import ParticipantList from "@/views/loyalty/components/participant/ParticipantList"
import UserProfileList from "@/views/loyalty/components/user_profile/UserProfileList"
import { localStock } from "@/views/loyalty/shared/classes/local_stock"
import { JustpayClient } from "@/views/loyalty/shared/services/justpay-client-service"
import CampaignOption from "@/views/loyalty/components/campaign/CampaignOption.vue"
export default {
    name: "CampaignForm",
    components: { CampaignEdit, CampaignOption, ConditionList, ParticipantList, PointList, RuleList, UserProfileList },
    data: () => ({
        name: "",
        description: "",
        status: false,
        campaign: {},
        campaignId: 0,
        campaignTab: 'campaign.tab',
        currentTab: 0,
        customerId: "",
        customerNumber: null,
        disabledTabItem: false,
        justpayClientService: null,
        role: 0,
        rule: {},
        webApi: null
    }),
    watch: {
        rule: {
            handler (newVal, oldVal) {
                // console.log('watch CampaignForm rule', this.rule)
            }
        },

    },
    async beforeMount () {
        // console.clear()
        this.justpayClientService = new JustpayClient()
        this.campaignId = +this.$route.params.campaign
        if (this.campaignId === 0) {
            this.disabledTabItem = true
        }
        this.role = +this.$route.params.role
        console.log('campaignId', this.campaignId)
        this.customerId = this.$route.params.customer
        console.log("mounted this.customerId=", this.customerId)
        this.customerNumber = await this.justpayClientService.getClientNumber(this.customerId)
        console.log('form customerNumber', this.customerNumber)
    },

    mounted () {
        /* this.currentTab = localStorage.getItem(this.campaignTab) ? +localStorage.getItem(this.campaignTab) : 0
        console.log('mounted currentTab', this.currentTab) */
        this.campaign = localStock.getItem('campaign')
        if (!this.customerNumber) {
            this.customerNumber = this.campaign.customerNumber
        }
        console.log('this.campaign store', this.campaign)
    },
    methods: {
        getRule ($event) {
            // console.log('getRule event', $event)
            this.rule = $event
        },
        getTabNumber ($event) {
            console.log('getTabNumber', $event)
            /* localStorage.setItem(this.campaignTab, $event) */
        }
    }
}
</script>

<style scoped>

</style>
